<!DOCTYPE html>
<html>
  <head>
    <!-- Basic -->
    <meta charset="utf-8" />
    <meta http-equiv="X-UA-Compatible" content="IE=edge" />
    <!-- Mobile Metas -->
    <meta
      name="viewport"
      content="width=device-width, initial-scale=1, shrink-to-fit=no"
    />
    <!-- Site Metas -->
    <meta name="keywords" content="" />
    <meta name="description" content="" />
    <meta name="author" content="" />

    <title>Newsoft</title>

    <!-- slider stylesheet -->
    <link
      rel="stylesheet"
      type="text/css"
      href="https://cdnjs.cloudflare.com/ajax/libs/OwlCarousel2/2.1.3/assets/owl.carousel.min.css"
    />

    <!-- bootstrap core css -->
    <link
      rel="stylesheet"
      type="text/css"
      href="/assets/css/Home/bootstrap.css"
    />

    <!-- fonts style -->
    <link
      href="https://fonts.googleapis.com/css?family=Poppins|Raleway:400,600|Righteous&display=swap"
      rel="stylesheet"
    />
    <!-- Custom styles for this template -->
    <!-- responsive style -->
    <link href="/assets/css/Home/responsive.css" rel="stylesheet" />
  </head>

  <body>
    <div class="hero_area">
      <!-- header section strats -->
      <header class="header_section">
        <div class="container-fluid">
          <nav class="navbar navbar-expand-lg custom_nav-container">
            <a class="navbar-brand" href="index.html">
              <span> Mapix </span>
            </a>

            <div class="navbar-collapse" id="">
              <div
                class="d-none d-lg-flex ml-auto flex-column flex-lg-row align-items-center mt-3"
              >
                
              </div>

              <div class="custom_menu-btn">
                <button mat-button (click)="Logout()" class="btnLogout">
                  Ingresar
                </button>
              </div>
              <div id="myNav" class="overlay">
                <div class="overlay-content">
                  <a href="">Home</a>
                  <a href="">About</a>
                </div>
              </div>
            </div>
          </nav>
        </div>
      </header>
      <!-- end header section -->
      <!-- slider section -->
      <section class="slider_section position-relative">
        <div class="container">
          <div
            id="carouselExampleControls"
            class="carousel slide"
            data-ride="carousel"
          >
            <div class="carousel-inner">
              <div class="carousel-item active">
                <div class="slider_item-box">
                  <div class="slider_item-container">
                    <div class="slider_item-detail">
                      <h1 class="title">MAPIX IA</h1>
                      <h1>
                        EXPERIENCIAS EN TIEMPO REAL CON INTELIGENCIA ARTIFICIAL
                      </h1>
                      <p>
                        Brindamos seguimiento puntual de activos enfocados en
                        dar tranquilidad a nuestros clientes a través de
                        nuestras soluciones con inteligencia artificial.
                      </p>
                      <div>
                        <a href=""> Conocer más </a>
                      </div>
                    </div>
                    <div class="slider_item-imgbox">
                      <img src="/assets/img/Home/pc-banner.png" alt="" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <!-- end slider section -->
    </div>

    <!-- about section -->

    <section class="about_section layout_padding">
      <div class="container">
        <h2 class="text-uppercase">Nuestros Servicios</h2>
      </div>

      <div class="container">
        <div class="about_card-container layout_padding2-top">
          <div class="about_card">
            <div class="about-detail">
              <div class="about_img-container">
                <div class="about_img-box">
                  <img src="/assets/img/Home/gps_PNG29.png" alt="" />
                </div>
              </div>
              <div class="card_detail-ox">
                <h4>TRACKING 24/7</h4>
                <p>
                  Enfocados en garantizar la seguridad de sus activos,
                  proporcionamos una herramienta tecnológica de última
                  generación para conocer el último estado de nuestros activos,
                  flotillas o cargas.
                </p>
              </div>
            </div>
          </div>
          <div class="about_card">
            <div class="about-detail">
              <div class="about_img-container">
                <div class="about_img-box">
                  <img src="/assets/img/Home/work2.png" alt="" />
                </div>
              </div>
              <div class="card_detail-ox">
                <h4>CONTROL INTEGRADO DE FLOTILLAS</h4>
                <p>
                  De UNO a UN MILLON de Activos, gestiona todos tus recursos en
                  un mismo sitio, conoce su última ubicación y revisa su
                  historial de ruta.
                </p>
              </div>
            </div>
          </div>
          <div class="about_card">
            <div class="about-detail">
              <div class="about_img-container">
                <div class="about_img-box">
                  <img src="/assets/img/Home/work3.png" alt="" />
                </div>
              </div>
              <div class="card_detail-ox">
                <h4>BUSSINES GEOINTELLIGENT</h4>
                <p>
                  Proporcionamos geointeligencia para tu negocio enfocados en
                  hábitos de conducción, límites de velocidad, consumo
                  vehicular, seguimiento geoespacial y capas de información
                  externa con la que puedes llevar tu negocio a otro nivel.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- end about section -->

    <!-- mapix section -->
    <section class="who_section">
      <div class="container who_container">
        <div class="who_img-box">
          <img src="/assets/img/Home/pc.jpg" alt="" />
        </div>
        <div class="who_deail-box">
          <h2>Qué es MAPIX</h2>
          <p>
            Es un Sistema de Información Geoespacial (SIG) basado en
            <strong>Cloud </strong> que proporciona
            <strong> seguimiento en tiempo real </strong> a través de
            <strong>dispositivos GPS y tracking geoespacial </strong> para
            proporcionar seguimiento de flotillas, regular hábitos de
            conducción, zonas de influencia, historiales de rutas, control de
            activos por zonas a través de
            <strong
              >Geocercas, Alertas, Valet Parking y Análisis Geointeligente
            </strong>
            a través de recolección de datos, administración, control y
            supervisión de activos.
          </p>
          <div>
            <a href=""> Conocer Más </a>
          </div>
        </div>
      </div>
    </section>

    <!-- end mapix section -->

    <!-- feature section  -->
    <section class="feature_section layout_padding">
      <div class="container">
        <h2 class="text-uppercase">Nuestras Características</h2>
      </div>
      <div class="">
        <div class="feature_card-container layout_padding2">
          <div class="feature_card">
            <div class="feature_img-container">
              <div class="feature_img-box">
                <img src="/assets/img/Home/f1.png" alt="" />
              </div>
            </div>
            <div class="feature_detail-box">
              <h4>HERRAMIENTA MADE IN HOME</h4>
              <p>
                Proporcionamos una experiencia única ya que es desarrollada en
                casa.
              </p>
            </div>
          </div>
          <div class="feature_card">
            <div class="feature_img-container">
              <div class="feature_img-box">
                <img src="/assets/img/Home/f2.png" alt="" />
              </div>
            </div>
            <div class="feature_detail-box">
              <h4>PAAS</h4>
              <p>
                Operamos bajo el esquema plataforma como servicio, soportada por
                infaestructura escalable y completamente operativa 24/7
              </p>
            </div>
          </div>
          <div class="feature_card">
            <div class="feature_img-container">
              <div class="feature_img-box">
                <img src="/assets/img/Home/f3.png" alt="" />
              </div>
            </div>
            <div class="feature_detail-box">
              <h4>LIBRE DE MANTENIMIENTO</h4>
              <p>
                Despreocupate de la operación, nosotros nos encargamos de la
                administración de los activos.
              </p>
            </div>
          </div>
          <div class="feature_card">
            <div class="feature_img-container">
              <div class="feature_img-box">
                <img src="/assets/img/Home/f4.png" alt="" />
              </div>
            </div>
            <div class="feature_detail-box">
              <h4>MULTIPLATAFORMA</h4>
              <p>
                Operamos sobre dispositivos móviles, equipos de escritorio y
                tabletas móviles.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- end feature section -->

    <!-- footer section -->
    <section class="container-fluid footer_section">
      <p>
        &copy; 2022 All Rights Reserved. Mapix is technology operated by
        <a href="https://html.design/">Geointelligent</a>
      </p>
    </section>
    <!-- footer section -->

    <script type="text/javascript" src="js/jquery-3.4.1.min.js"></script>
    <script type="text/javascript" src="js/bootstrap.js"></script>

    <script>
      function openNav() {
        document.getElementById("myNav").classList.toggle("menu_width");
        document
          .querySelector(".custom_menu-btn")
          .classList.toggle("menu_btn-style");
      }
    </script>
  </body>
</html>
